import * as React from "react";
import { forwardRef } from "react";
const SvgExternalLink = (props, ref) => /* @__PURE__ */ React.createElement("svg", {
	fill: "none",
	height: "1em",
	viewBox: "0 0 12 12",
	width: "1em",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props
}, /* @__PURE__ */ React.createElement("path", {
	d: "M9.33328 6.55558V9.8889C9.33328 10.1836 9.21622 10.4662 9.00785 10.6746C8.79947 10.8829 8.51686 11 8.22218 11H2.1111C1.81642 11 1.53381 10.8829 1.32543 10.6746C1.11706 10.4662 1 10.1836 1 9.8889V3.77782C1 3.48314 1.11706 3.20053 1.32543 2.99215C1.53381 2.78378 1.81642 2.66672 2.1111 2.66672H5.44442M7.66687 1H11.0002M11.0002 1V4.33331M11.0002 1L4.88895 7.11107",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round"
}));
const ForwardRef = forwardRef(SvgExternalLink);
export default ForwardRef;
